<template>
  <div>
    <div class="status-box">
      <div class="img-box">
        <img :src="cover_src" alt="" />
        <p class="">{{message}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default { 
  data() {
    return {
      
    };
  }, 
  methods: {
    
  },
  mounted() {},
  props:['message','cover_src']
};
</script> 

<style>

</style>
